import { render, staticRenderFns } from "./detailedBillDialog.vue?vue&type=template&id=389ef047"
import script from "./detailedBillDialog.vue?vue&type=script&lang=js"
export * from "./detailedBillDialog.vue?vue&type=script&lang=js"
import style0 from "./detailedBillDialog.vue?vue&type=style&index=0&id=389ef047&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports